export class State {
	stateCode: string;
	stateName: string;
	stateWithCode: string;
}
